import { createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createVNode("header", {
  class: "bg-white shadow h-32 w-full object-cover lg:h-48",
  style: {"background-image":"url('https://images.unsplash.com/photo-1444628838545-ac4016a5418a?ixid=MXwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHw%3D&ixlib=rb-1.2.1&auto=format&fit=crop&w=1950&q=80')","background-repeat":"no-repat","background-size":"cover","background-blend-mode":"multiply"}
}, [
  /*#__PURE__*/_createVNode("div", { class: "max-w-7xl mx-auto pt-28 py-6 px-4 sm:px-6 lg:px-8" }, [
    /*#__PURE__*/_createVNode("h1", { class: "text-4xl font-bold text-white" }, " Our work ")
  ])
], -1)
const _hoisted_2 = {
  class: "bg-white border-b border-gray-200 flex",
  "aria-label": "Breadcrumb"
}
const _hoisted_3 = { class: "max-w-screen-xl w-full mx-auto px-4 flex space-x-4 sm:px-6 lg:px-8" }
const _hoisted_4 = { class: "flex" }
const _hoisted_5 = { class: "flex items-center" }
const _hoisted_6 = /*#__PURE__*/_createVNode("svg", {
  class: "flex-shrink-0 h-5 w-5",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 20 20",
  fill: "currentColor",
  "aria-hidden": "true"
}, [
  /*#__PURE__*/_createVNode("path", { d: "M10.707 2.293a1 1 0 00-1.414 0l-7 7a1 1 0 001.414 1.414L4 10.414V17a1 1 0 001 1h2a1 1 0 001-1v-2a1 1 0 011-1h2a1 1 0 011 1v2a1 1 0 001 1h2a1 1 0 001-1v-6.586l.293.293a1 1 0 001.414-1.414l-7-7z" })
], -1)
const _hoisted_7 = /*#__PURE__*/_createVNode("span", { class: "sr-only" }, "Home", -1)
const _hoisted_8 = { class: "flex" }
const _hoisted_9 = { class: "flex items-center" }
const _hoisted_10 = /*#__PURE__*/_createVNode("svg", {
  class: "flex-shrink-0 w-6 h-full text-gray-200",
  viewBox: "0 0 24 44",
  preserveAspectRatio: "none",
  fill: "currentColor",
  xmlns: "http://www.w3.org/2000/svg",
  "aria-hidden": "true"
}, [
  /*#__PURE__*/_createVNode("path", { d: "M.293 0l22 22-22 22h1.414l22-22-22-22H.293z" })
], -1)
const _hoisted_11 = /*#__PURE__*/_createTextVNode("Our work")
const _hoisted_12 = /*#__PURE__*/_createVNode("main", null, [
  /*#__PURE__*/_createVNode("div", { class: "max-w-7xl mx-auto py-6 sm:px-6 lg:px-8" }, [
    /*#__PURE__*/_createVNode("div", { class: "px-4 py-6 sm:px-0" }, [
      /*#__PURE__*/_createVNode("div", { class: "border-4 border-dashed border-gray-200 rounded-lg h-96" })
    ])
  ])
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")

  return (_openBlock(), _createBlock(_Fragment, null, [
    _hoisted_1,
    _createVNode("nav", _hoisted_2, [
      _createVNode("ol", _hoisted_3, [
        _createVNode("li", _hoisted_4, [
          _createVNode("div", _hoisted_5, [
            _createVNode(_component_router_link, {
              to: "/",
              class: "text-gray-400 hover:text-gray-500"
            }, {
              default: _withCtx(() => [
                _hoisted_6,
                _hoisted_7
              ]),
              _: 1
            })
          ])
        ]),
        _createVNode("li", _hoisted_8, [
          _createVNode("div", _hoisted_9, [
            _hoisted_10,
            _createVNode(_component_router_link, {
              to: "/work",
              class: "ml-4 text-sm font-bold text-indigo-600 hover:text-gray-700"
            }, {
              default: _withCtx(() => [
                _hoisted_11
              ]),
              _: 1
            })
          ])
        ])
      ])
    ]),
    _hoisted_12
  ], 64))
}